import axios from 'axios';

import { Provider } from 'signIn/redirectSignIn';

// The Client Portal API owns portal sign-in, so the same-tab flow talks to it rather than the main API.
// Its address is resolved per portal (see resolveClientPortalApiUrl) and passed in by the caller.

export interface ISsoReturnUrlResult {
  returnUrl: string;
}

export interface ISsoHandoffResult {
  code: string;
  returnUrl: string;
}

const jsonHeaders = { 'Content-Type': 'application/json' };

export const validateReturnUrl = async (
  apiUrl: string,
  returnUrl: string,
): Promise<ISsoReturnUrlResult> =>
  (
    await axios.post<ISsoReturnUrlResult>(
      `${apiUrl}/ClientPortalAuth/sso/return-url`,
      { returnUrl },
      { headers: jsonHeaders },
    )
  ).data;

export const createHandoff = async (
  apiUrl: string,
  payload: { token: string; tokenType: Provider; returnUrl: string },
): Promise<ISsoHandoffResult> =>
  (
    await axios.post<ISsoHandoffResult>(`${apiUrl}/ClientPortalAuth/sso/handoff`, payload, {
      headers: jsonHeaders,
    })
  ).data;
